import * as React from 'react';
import { connect, Dispatch } from 'react-redux';

import * as Actions from '../actions';
import { AnalyseState } from '../interfaces/state';
import { CoughAnalysisSetComment, OverreadStatusEnum } from '../../../misc/api/apiTypes';
import { AuditModal } from "../../../auditmodal/components/AuditModal";
import once from 'lodash-es/once';
import { useWebPortalApiClient, useWebPortalLegacyClient, WebPortalLegacyClientInternal } from '../../../misc/api/WebPortalTokenClient';
import { useHistory } from 'react-router-dom';
import { OnIgnoreEnter } from '../AnalyseApp';
import { SendForVisualReviewModalBody } from '../../../cough-analysis/SendForVisualReviewModal/SendForVisualReviewModal';
import { useQuery } from '../../../Components/Query';
import { CoughAnalysisSet } from 'webportalclient';

interface VisualInspectionDashboardProps {
    isVisible: boolean;
    primaryAnalysisSetId: string;
    acceptabilityModalVisiblility: boolean;
    selectedAcceptability: OverreadStatusEnum;
    isSubmitting: boolean;
    coughAnalysisSet: CoughAnalysisSet;
    comments: CoughAnalysisSetComment[];
    dispatch?: Dispatch<AnalyseState>;
    blindComments: boolean;
    selectedSegment: number;
    errorState: string;
}


export const VisualInspectionDashboard = (props: VisualInspectionDashboardProps) => {
    const legacyClient = useWebPortalLegacyClient();
    const history = useHistory();
    const client = useWebPortalApiClient();
    const [sendForVisualReviewVisible, setSendForVisualReviewVisible] = React.useState(false);
    const { refresh } = useQuery();

    const handleReturnToAnalyst = (analysisSetId: string, status: number) => {
        legacyClient.updateVisualReviewAnalystSelectionStatus(analysisSetId, status).then(json => {
            var location = history.location;
            location.pathname = location.pathname.replace('false', 'true');
            history.replace(location);
            history.push("/cough/analysis")

        });
    }

    const handleSendAnalysisSetForVisualReview = (analysisSetId: string) => {
        setSendForVisualReviewVisible(true);

    }

    const onSubmit = once((audit) => {
        props.dispatch(Actions.AcceptabilitySetAsyncAction.create(legacyClient, client.client, history, props.primaryAnalysisSetId, props.selectedAcceptability, audit.Annotation));
    })

    if (props.isVisible) {
        return (
            <>
                <div className="panel panel-default">
                    <div className="panel-body">
                        <button className="btn btn-success" disabled={props.isSubmitting} onClick={() => handleReturnToAnalyst(props.primaryAnalysisSetId, 0)} onKeyDown={OnIgnoreEnter}>
                            No Changes
                        </button>&nbsp;
                        <button className="btn btn-warning" disabled={props.isSubmitting} onClick={() => handleReturnToAnalyst(props.primaryAnalysisSetId, 1)} onKeyDown={OnIgnoreEnter}>
                            Apply Changes & Accept
                        </button>&nbsp;
                        <button className="btn btn-danger" disabled={props.isSubmitting} onClick={() => handleReturnToAnalyst(props.primaryAnalysisSetId, 2)} onKeyDown={OnIgnoreEnter}>
                            Apply Changes, Further Review Required
                        </button>&nbsp;
                        <button className="btn btn-primary" disabled={props.isSubmitting} onClick={() => { handleSendAnalysisSetForVisualReview(props.primaryAnalysisSetId); }} onKeyDown={OnIgnoreEnter}>
                            View/Add Review Comments
                        </button>
                    </div>
                </div>
                {sendForVisualReviewVisible ?
                    <SendForVisualReviewModalBody
                        dispatch={props.dispatch}
                        analysisSetId={props.primaryAnalysisSetId}
                        coughAnalysisSet={props.coughAnalysisSet}
                        blindComments={props.blindComments}
                        errorStatus={props.errorState}
                        comments={props.comments}
                        selectedSegment={props.selectedSegment}
                        onClose={() => { setSendForVisualReviewVisible(false); refresh(); }} /> : null}
                {props.acceptabilityModalVisiblility ?
                    <AuditModal header="Analysis Approval"
                        isSubmitting={props.isSubmitting}
                        onSubmit={onSubmit}
                        onClose={() => props.dispatch(Actions.CloseAcceptabilityAuditModalAction.create())} />
                    : null}
            </>
        );
    } else {
        return null;
    }
}

function mapStateToProps(state: AnalyseState): VisualInspectionDashboardProps {

    return {
        isVisible: !state.core.isViewOnly || state.core.coughAnalysisSet.visualReview,
        primaryAnalysisSetId: state.analysisSet.primaryAnalystSetId,
        acceptabilityModalVisiblility: state.core.isAcceptabilityAuditModalVisible,
        selectedAcceptability: state.core.acceptabilityStatus,
        isSubmitting: state.core.isSubmitting,
        comments: state.core.comments,
        coughAnalysisSet: state.core.coughAnalysisSet,
        blindComments: state.core.blindComments,
        selectedSegment: state.core.selectedSegment,
        errorState: state.core.visualInspectionErrorMessage,
    } as VisualInspectionDashboardProps;
}

export default connect<VisualInspectionDashboardProps, any, void>(mapStateToProps)(VisualInspectionDashboard);
